module.exports = __webpack_public_path__ + "img/U1F514.e6b09b99.png";